import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import { Service } from '../service';
import { statusPreparation } from './constants/status.constant';
import { typeDelivery } from './constants/type-delivery.constant';
import { generateColumns } from './handle/generate-columns.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { tabOptions } from './handle/tab-options.handle';
import './style.css';
import Loading from '../../../v2-components/Loading';
import Pharmacies from '../../../v2-components/Pharmacies';
import { GetAllPharmacies } from '../../../_config/utils/get-all-pharmacies.util';
import { SelectAll } from '../../../_config/constants/select-all.constant';
import { mapOptions } from './handle/map-options.handle';

export default function QuotationListAdminPage() {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const history = useHistory();
	const location = useLocation();

	const searchParams = new URLSearchParams(location?.search);
	const page = searchParams.get('page');
	const statusQueryParam = searchParams.get('status');
	const [status, setStatus] = useState(statusQueryParam);
	const [paginationResponse, setPaginationResponse] = useState();
	const rowKey = '_id';
	const pharmacyQueryParam = searchParams.get('pharmacy');
	const [pharmacy, setPharmacy] = useState(pharmacyQueryParam);
	const [options, setOptions] = useState();



	const pagination = {
		currentPage: paginationResponse?.currentPage,
		pageSize: paginationResponse?.itemsPerPage,
		totalItems: paginationResponse?.totalItems,
	};

	useEffect(() => {
		Promise.all([new Service().getData(status, page, pharmacy), new Service().getPharmacies()])
			.then(([quotationResponse, pharmaciesResponse]) => {
				setPaginationResponse(quotationResponse);
				setData(quotationResponse.data);
				setIsLoading(false);
				setOptions([SelectAll[Enviroment.LANGUAGE], ...mapOptions(pharmaciesResponse?.data)]);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [status, page, pharmacy]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleStatusQueryChange = (status) => {
		searchParams.set('status', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleDropdownSelect = (key) => {
		setStatus(key);
		handleStatusQueryChange(key);
	};
	const handleDropdownDelivery = (key) => {
	};


	const handleTabClick = (key) => {
		const tab = tabOptions(data).find((tab) => tab.key === key);
		if (tab) {
			setStatus(tab.status);
			handleStatusQueryChange(tab.status);
			onTabChange();
		}
		const filteredData = tabOptions(data).map((tab) => ({
			...tab,
			data: tab.data?.filter((item) => {
				return item;
			}),
		}));

		return filteredData;
	};

	const paginationConfig = {
		current: pagination.currentPage,
		pageSize: pagination.pageSize,
		total: pagination.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const handleSelectChange = (value) => {
		GetAllPharmacies(value, setPharmacy);
		if (value !== 'all') {
			searchParams.set('pharmacy', value);
		 } else{searchParams.delete('pharmacy')}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};


	const initialActiveTab = tabOptions(data).find((tab) => tab.status === status)?.key;

	const itemsDropdownDelivery = [
		{
			key: 'todas',
			label: typeDelivery[Enviroment.LANGUAGE]['all'],
			value: 'all',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'farmacia',
			label: typeDelivery[Enviroment.LANGUAGE]['pharmacy'],
			value: 'pharmacy',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'domicilio',
			label: typeDelivery[Enviroment.LANGUAGE]['home'],
			value: 'home',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'mixto',
			label: typeDelivery[Enviroment.LANGUAGE]['mixed'],
			value: 'mixed',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
	];

	const itemsDropdownStatus = [
		{
			key: 'all',
			label: statusPreparation[Enviroment.LANGUAGE]['all'],
			value: 'null',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '001',
			label: statusPreparation[Enviroment.LANGUAGE]['001'],
			value: '001',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '002',
			label: statusPreparation[Enviroment.LANGUAGE]['002'],
			value: '002',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '003',
			label: statusPreparation[Enviroment.LANGUAGE]['003'],
			value: '003',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '101',
			label: statusPreparation[Enviroment.LANGUAGE]['101'],
			value: '101',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '201',
			label: statusPreparation[Enviroment.LANGUAGE]['201'],
			value: '201',
			onClick: (e) => handleDropdownSelect(e.key),
		},
	];

	if (isLoading) {
		return <Loading />;
	}
	if (isLoading === false) {
		return (
			<div className="tracking-orders-list-container">
				<Row>
					<Col span={8}>
						<h2>Cotizaciones</h2>
					</Col>
				</Row>
				<Row justify="left">
				<span>Filtrar por:</span>
				<Pharmacies style={{ width: '50%', marginLeft: '10px' }} onChange={handleSelectChange} options={options} />
			</Row>
				<Row>
					<Col span={24}>
						<Col className={'own-order-main-container'}>
						{/* <CustomTabs tabBarExtraContent={operations} onChange={handleTabClick} activeKey={initialActiveTab}> */}
							<CustomTabs  onChange={handleTabClick} activeKey={initialActiveTab}>
								{handleTabClick().map((tab) => (
									<CustomTabs key={tab.key} tab={tab.tab}>
										<CustomTable
											dataSource={tab.data}
											columns={generateColumns(itemsDropdownDelivery, itemsDropdownStatus, status)}
											pagination={paginationConfig}
											rowKey={rowKey}
										/>
									</CustomTabs>
								))}
							</CustomTabs>
						</Col>
					</Col>
				</Row>
			</div>
		);
	}
}
